__turbopack_context__.v({
  "root": "Trampoline-module__pUBf5a__root",
  "trampolineImage": "Trampoline-module__pUBf5a__trampolineImage",
});
